import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export function LoadingScreen() {
  const [show, setShow] = useState(true);
  const [visible, setVisible] = useState(true); // DOMから完全に消すフラグ
  const [phase, setPhase] = useState<"logo" | "fade">("logo");

  useEffect(() => {
    // Check if already visited this session
    const visited = sessionStorage.getItem("pw_visited");
    if (visited) {
      setShow(false);
      setVisible(false);
      return;
    }
    sessionStorage.setItem("pw_visited", "1");

    // Phase: show logo for 2.2s, then fade out
    const t1 = setTimeout(() => setPhase("fade"), 2200);
    const t2 = setTimeout(() => setShow(false), 3000);
    // フェード完了後に display:none で完全に除去
    const t3 = setTimeout(() => setVisible(false), 3900);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, []);

  if (!visible) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="loader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8, ease: "easeInOut" }}
          className="fixed inset-0 z-[99999] flex flex-col items-center justify-center"
          style={{ background: "oklch(0.06 0.01 240)", willChange: "opacity" }}
        >
          {/* Background subtle glow */}
          <motion.div
            animate={{ scale: [1, 1.3, 1], opacity: [0.2, 0.4, 0.2] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            className="absolute w-96 h-96 rounded-full pointer-events-none"
            style={{
              background: "radial-gradient(circle, oklch(0.55 0.18 195 / 0.3) 0%, transparent 70%)",
            }}
          />

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={phase === "logo" ? { opacity: 1, y: 0 } : { opacity: 0, y: -10 }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="relative z-10 text-center"
          >
            <h1
              className="text-4xl md:text-6xl font-light tracking-[0.3em] mb-3 title-hue-cycle"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              PictWork STUDIO
            </h1>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 1.2, delay: 0.4, ease: "easeInOut" }}
              className="h-px mx-auto"
              style={{
                width: "200px",
                background: "linear-gradient(to right, transparent, oklch(0.75 0.18 195 / 0.6), transparent)",
                transformOrigin: "center",
              }}
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.5 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="text-xs tracking-[0.5em] mt-3 uppercase"
              style={{ color: "oklch(0.65 0.05 240)", fontFamily: "'Rajdhani', sans-serif" }}
            >
              Visual Artist / AI Filmmaker
            </motion.p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
